import React, { useMemo, useEffect } from "react";
import * as S from "./index-styled";
import isempty from "lodash/isEmpty";
import PT from "prop-types";
import Tooltip from "_c/Tooltip";
import { ACHIEVE_ICONS_ROOT } from "@/misc/constants";
import Info from "_c/atoms/Info";
import provide from "./provider";

const Achieve = ({ progress, achievesList }) => {
  const achieve = achievesList.find(({ slug }) => slug === progress.slug);
  // deprecated safe probably, handle it when we implement safe deals
  if (!achieve) return null;
  const rank = achieve.ranks.find(({ rank }) => rank === progress.rank);
  if (!rank) return null;
  return (
    <li>
      <Tooltip title={`${rank.title} (${rank.desc})`}>
        <img src={ACHIEVE_ICONS_ROOT + rank.icon + ".png"} />
      </Tooltip>
    </li>
  );
};

const AchievesList = ({ t, ...props }) => {
  const achievesWithRanks = useMemo(() => {
    if (isempty(props.achieves)) return [];
    return props.achieves.filter((achieve) => achieve.rank !== 0);
  }, [props.achieves]);
  useEffect(() => {
    if (isempty(props.achievesList)) {
      props.loadAchieves();
    }
  }, [props.achievesList]);
  if (isempty(props.achievesList)) return null;
  return (
    <div className={props.className}>
      {isempty(achievesWithRanks) ? (
        props.isOwner ? (
          <Info>
            <span>{t("common:profile_common.achieves_empty_user")}</span>{" "}
            <S.AchievesLink to={`/${props.pageType}/achievements`}>
              {t("common:here").toLowerCase()}
            </S.AchievesLink>
          </Info>
        ) : (
          <Info>{t("common:profile_common.achieves_empty_guest")}</Info>
        )
      ) : (
        <S.List>
          {achievesWithRanks.map((progress) => (
            <Achieve
              achievesList={props.achievesList}
              key={progress.slug}
              progress={progress}
            />
          ))}
        </S.List>
      )}
    </div>
  );
};
AchievesList.propTypes = {
  achieves: PT.array,
  className: PT.string,
  isOwner: PT.bool,
  pageType: PT.oneOf(["client", "master"]),

  t: PT.func.isRequired,
};
export default provide(AchievesList);
